import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ApplicationStore } from 'app/stores/application-store';

@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {
  constructor(private router: Router, private _applicationStore: ApplicationStore) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const authToken = this._applicationStore.authenticationStore.getAuthorizationToken();

    req = req.clone({
      withCredentials: true,
      headers: req.headers.set('Authorization', `Bearer ${authToken}`)
    });

    return next.handle(req).pipe(map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        if(event.status === 205){
          // this status is returned from the service when maintenance mode is on
          this.router.navigate(['login']);
          return;
        }
      }
      return event;
  }));
  }
}
